var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148,
    height: 145,
    viewBox: "0 0 148 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_3",
    x: 0,
    y: 0,
    width: 148,
    height: 145,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Polygon_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_3-2",
    "data-name": "Polygon 3",
    transform: "translate(63 48)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.269,2.99a2,2,0,0,1,3.462,0L20.262,16a2,2,0,0,1-1.731,3H3.469a2,2,0,0,1-1.731-3Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.99999904632568 2.991722106933594 C 10.8266487121582 2.991722106933594 10.39529895782471 3.040342330932617 10.13457870483398 3.490692138671875 L 2.603469848632812 16.49897193908691 C 2.342199325561523 16.95024108886719 2.515798568725586 17.34899139404297 2.602569580078125 17.49948120117188 C 2.689329147338867 17.64997291564941 2.947439193725586 18.00000190734863 3.468898773193359 18.00000190734863 L 18.53110885620117 18.00000190734863 C 19.05255889892578 18.00000190734863 19.3106689453125 17.64997291564941 19.39742851257324 17.49948120117188 C 19.48419952392578 17.34899139404297 19.65779876708984 16.95024108886719 19.39652824401855 16.49897193908691 L 11.86541938781738 3.490692138671875 C 11.60469913482666 3.040342330932617 11.17334938049316 2.991722106933594 10.99999904632568 2.991722106933594 M 10.99999904632568 1.991724014282227 C 11.67284107208252 1.991724014282227 12.34568405151367 2.324367523193359 12.73084926605225 2.989652633666992 L 20.26195907592773 15.99793243408203 C 21.03388977050781 17.33126258850098 20.07176971435547 19.00000190734863 18.53110885620117 19.00000190734863 L 3.468898773193359 19.00000190734863 C 1.928228378295898 19.00000190734863 0.9661083221435547 17.33126258850098 1.738039016723633 15.99793243408203 L 9.269148826599121 2.989652633666992 C 9.654314041137695 2.324367523193359 10.32715702056885 1.991724014282227 10.99999904632568 1.991724014282227 Z",
    stroke: "none",
    fill: "rgba(28,33,45,0.05)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIcon);
export default __webpack_public_path__ + "static/media/top-icon.9ea80db72287ed3dcc3121870fd87e80.svg";
export { ForwardRef as ReactComponent };